import React from "react";

const Loader = () => {
  return (
    <div className="animated fadeIn pt-3 text-center loader">
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
